import { Link } from "react-router-dom";
import { BadgeCheck, Building2, Leaf, ShieldCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const VALUES = [
  {
    icon: Building2,
    title: "प्रीमियम इंजीनियरिंग",
    text: "AERO D crossover, off-road SUV और 100% Electric — हर model में powerful performance, 360° safety और smart connectivity।",
  },
  {
    icon: ShieldCheck,
    title: "पूरी पारदर्शिता",
    text: "कोई hidden charges नहीं — सिर्फ ₹10,000 का refundable token, साफ़-साफ़ pricing और अपने आवाज़ का वादा।",
  },
  {
    icon: Leaf,
    title: "बेहतर कल",
    text: "January 2028 से delivery — diesel में दम और electric में नया जादू, दोनों के लिए एक ही बेहतर कल।",
  },
];

export default function About() {
  return (
    <div className="mx-auto max-w-5xl px-5 pb-24 pt-40 sm:px-8" data-testid="about-page">
      <Reveal className="text-center">
        <p className="eyebrow">About IshuKart</p>
        <h1 className="mt-4 font-display text-4xl font-extrabold uppercase text-white sm:text-5xl">
          Drive a <span className="text-gold-gradient">Better Tomorrow</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-neutral-400 sm:text-base">
          IshuKart प्रीमियम वाहनों का घर है — जहाँ आप अपनी सपनों की कार को सिर्फ ₹10,000 के
          refundable token से reserve करते हैं और Founding Owner बन जाते हैं। नई सोच... हर रास्ते के लिए एक बेहतर कल।
        </p>
      </Reveal>

      <Reveal className="mt-14">
        <div className="grid gap-5 md:grid-cols-3">
          {VALUES.map((v) => (
            <div key={v.title} className="card-glow rounded-2xl p-7" data-testid={`about-value-${v.title.length}`}>
              <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-[#e6b800]/30 bg-[#e6b800]/10 text-[#e6b800]">
                <v.icon size={18} />
              </span>
              <h2 className="mt-5 font-display text-lg font-bold uppercase text-white">{v.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-neutral-400">{v.text}</p>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal className="mt-14">
        <div className="rounded-2xl border border-white/10 bg-[#0a0a0e] p-8 sm:p-10">
          <h2 className="font-display text-2xl font-extrabold uppercase text-white">हमारा वादा</h2>
          <ul className="mt-6 space-y-4 text-sm leading-relaxed text-neutral-300">
            <li className="flex items-start gap-3">
              <BadgeCheck size={17} className="mt-0.5 shrink-0 text-[#e6b800]" />
              हर booking पर <strong className="text-white">Founding Owner</strong> status — priority delivery queue और exclusive badge।
            </li>
            <li className="flex items-start gap-3">
              <BadgeCheck size={17} className="mt-0.5 shrink-0 text-[#e6b800]" />
              Token कभी ज़बरदस्ती नहीं — <strong className="text-white">100% refundable ₹10,000</strong>, हमेशा आपकी मर्ज़ी।
            </li>
            <li className="flex items-start gap-3">
              <BadgeCheck size={17} className="mt-0.5 shrink-0 text-[#e6b800]" />
              Delivery का वादा — <strong className="text-white">January 2028</strong>, तय समय पर, तय कीमत पर।
            </li>
          </ul>
          <Link
            to="/booking"
            data-testid="about-booking-cta"
            className="mt-8 inline-block rounded-full bg-[#e6b800] px-8 py-3 text-sm font-bold text-[#070709] transition-colors duration-200 hover:bg-[#ffc700]"
          >
            अपनी IshuCar बुक करें
          </Link>
        </div>
      </Reveal>
    </div>
  );
}
